<template>
  <div class="flex gap-spacing_4 border-b border-primary-200">
    <button
      v-for="tab in tabs"
      class="flex w-[209px] items-center justify-center gap-spacing_2 px-spacing_8 py-spacing_6 font-secondary text-size_5"
      :class="{
        'border-b-2 border-action': selectedId === tab.id,
      }"
      @click="$emit('select', tab.id)"
    >
      <CommonUIcons
        :name="tab.prefix_icon"
        :class="{
          'text-primary-800': selectedId === tab.id,
        }"
      />

      <p
        :class="{
          'font-semibold text-primary-800': selectedId === tab.id,
        }"
      >
        {{ tab.label }}
      </p>

      <span
        class="flex h-[22px] w-[23px] items-center justify-center rounded-full bg-neutral-200 text-size_1 font-medium text-neutral-700"
      >
        {{ tab.count }}
      </span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { CommonUIcons } from "#components";
import { IconNamesType } from "~/types/Icons";

type TabSchema = {
  id: string;
  label: string;
  count: number;
  prefix_icon?: IconNamesType;
};

defineProps<{
  selectedId?: string;
  tabs: TabSchema[];
}>();

defineEmits<{
  select: [id: string];
}>();
</script>
